import React from 'react';
import { Phone, MessageSquare } from 'lucide-react';
import { Button } from './ui/button';

const Hero = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative bg-gradient-to-br from-emerald-50 to-white py-20 sm:py-32">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          {/* Badge */}
          <div className="inline-flex items-center bg-emerald-100 text-emerald-800 px-4 py-2 rounded-full text-sm font-semibold mb-6">
            Serving Hamilton & Surrounding Areas
          </div>

          {/* Headline */}
          <h1 className="text-4xl sm:text-5xl md:text-6xl font-bold text-gray-900 mb-6 leading-tight">
            Fast & Reliable
            <span className="text-emerald-600 block mt-2">Junk Removal in Hamilton, ON</span>
          </h1>
          
          {/* Licensed & Insured Badge */}
          <div className="inline-flex items-center bg-white border-2 border-emerald-600 px-6 py-3 rounded-lg shadow-md mb-6">
            <span className="text-emerald-600 font-bold text-lg">✓ Licensed & Insured</span>
          </div>

          {/* Subheadline */}
          <p className="text-lg sm:text-xl text-gray-600 mb-10 max-w-3xl mx-auto">
            Same-day service available. We haul away anything from furniture to construction debris. 
            Our trucks hold up to 14 yards. Locally owned, eco-friendly disposal, and upfront pricing.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <a href="tel:3653363364">
              <Button className="bg-emerald-600 hover:bg-emerald-700 text-white px-8 py-6 text-lg font-semibold rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 flex items-center">
                <Phone className="w-5 h-5 mr-2" />
                Call Now: (365) 336-3364
              </Button>
            </a>
            <Button 
              onClick={scrollToContact}
              variant="outline" 
              className="border-2 border-emerald-600 text-emerald-600 hover:bg-emerald-50 px-8 py-6 text-lg font-semibold rounded-lg transition-all duration-300 flex items-center"
            >
              <MessageSquare className="w-5 h-5 mr-2" />
              Get a Free Quote
            </Button>
          </div>

          {/* Trust Indicators */}
          <div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-8 max-w-4xl mx-auto">
            <div className="text-center">
              <div className="text-3xl font-bold text-emerald-600 mb-2">100+</div>
              <div className="text-gray-600 text-sm">Happy Customers</div>
            </div>
            <div className="text-center">
              <div className="text-3xl font-bold text-emerald-600 mb-2">Same Day</div>
              <div className="text-gray-600 text-sm">Service Available</div>
            </div>
            <div className="text-center">
              <div className="text-3xl font-bold text-emerald-600 mb-2">15% OFF</div>
              <div className="text-gray-600 text-sm">Junk Outside Ready</div>
            </div>
            <div className="text-center">
              <div className="text-3xl font-bold text-emerald-600 mb-2">Local</div>
              <div className="text-gray-600 text-sm">Owned & Operated</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;